import type { FrontofficeRuntime } from './frontofficeRuntime';

export const DESKTOP_QUIT_CHANNEL = 'app:quit';

export function shouldShowDesktopCloseButton(runtime: FrontofficeRuntime): boolean {
  return runtime === 'electron';
}

export function requestDesktopQuit(invoke: (channel: string) => unknown): void {
  invoke(DESKTOP_QUIT_CHANNEL);
}
